import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import CandlestickFinder from "./CandlestickFinder";

var DragonFlyDoji =
/*#__PURE__*/
function (_CandlestickFinder) {
  _inherits(DragonFlyDoji, _CandlestickFinder);

  function DragonFlyDoji() {
    var _this;

    _classCallCheck(this, DragonFlyDoji);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DragonFlyDoji).call(this));
    _this.requiredCount = 1;
    _this.name = "DragonFlyDoji";
    return _this;
  }

  _createClass(DragonFlyDoji, [{
    key: "logic",
    value: function logic(data) {
      var daysOpen = data.open[0];
      var daysClose = data.close[0];
      var daysHigh = data.high[0];
      var daysLow = data.low[0];
      var isOpenEqualsClose = this.approximateEqual(daysOpen, daysClose);
      var isHighEqualsOpen = isOpenEqualsClose && this.approximateEqual(daysOpen, daysHigh);
      var isLowEqualsClose = isOpenEqualsClose && this.approximateEqual(daysClose, daysLow);
      return isOpenEqualsClose && isHighEqualsOpen && !isLowEqualsClose;
    }
  }]);

  return DragonFlyDoji;
}(CandlestickFinder);

export { DragonFlyDoji as default };
export function dragonflydoji(data) {
  return new DragonFlyDoji().hasPattern(data);
}